function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "#F3F4F6"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_40113_1119)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M56 48.9859V56.0023H0V49.0116C3.25721 44.6587 7.48512 41.1257 12.3475 38.6937C17.2099 36.2617 22.5727 34.9977 28.0093 35.0023C39.452 35.0023 49.616 40.4949 56 48.9859ZM37.338 20.9999C37.338 23.4753 36.3547 25.8493 34.6043 27.5996C32.854 29.3499 30.48 30.3333 28.0047 30.3333C25.5293 30.3333 23.1553 29.3499 21.405 27.5996C19.6547 25.8493 18.6713 23.4753 18.6713 20.9999C18.6713 18.5246 19.6547 16.1506 21.405 14.4003C23.1553 12.6499 25.5293 11.6666 28.0047 11.6666C30.48 11.6666 32.854 12.6499 34.6043 14.4003C36.3547 16.1506 37.338 18.5246 37.338 20.9999Z",
  fill: "#D1D5DB"
}));

function SvgAvatarImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40113_1119",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarImage);
export default __webpack_public_path__ + "static/media/avatar-image.44d7f872.svg";
export { ForwardRef as ReactComponent };